import { useQuery } from '@tanstack/react-query';
import { apiWorker } from '../api/worker';

export interface DependentActivity {
  id: string;
  name: string;
  relation: string;
  org: string;
  type: string;
  detail: string;
  priority: 'HIGH' | 'NORMAL' | 'URGENT';
}

export interface UserDashboardData {
  dependentActivity: DependentActivity[];
  urgentAnnouncements: any[];
  upcomingEvents: any[];
}

export const useUserDashboard = (enabled: boolean = true) => {
  return useQuery<UserDashboardData>({
    queryKey: ['user-dashboard'],
    queryFn: async () => {
      const response = await apiWorker.get('/api/users/me/dashboard');
      return (response.data && Array.isArray(response.data.content)) ? response.data.content : response.data;
    },
    enabled,
    staleTime: 5 * 60 * 1000
  });
};
